import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { FlexWithGradientBackground, Icon } from '@atoms';
import { Flex, Typography } from '@mixins';
import { getCloudinaryImageLinkBySize } from '@helpers/common';
import { theme } from '@styles';
import { routes } from '@constants';

import ExploreLocation from '@assets/images/ExploreLocation.jpg';
import DefaultEvent from '@assets/images/DefaultEvent.png';
import { ReactComponent as Arrow } from '@assets/svgs/Arrow.svg';

const IMAGE_WIDTH = 325;

const HomeGrid = () => {
  const [eventsImage, setEventsImage] = useState();
  const [benefitsImage, setBenefitsImage] = useState();
  const history = useHistory();

  const { currentLocation } = useSelector(store => store.locationStore);

  const { metadata } = useSelector(store => store.metadataStore);

  const category = useMemo(
    () => metadata.eventCategories?.find(cat => cat.id === currentLocation.eventCategoryIdWithEvents),
    [currentLocation, metadata],
  );

  const onEventsClick = () => {
    history.push(routes.events);
  };

  const onMemberBenefitsClick = () => {
    history.push(routes.benefits);
  };

  const onExploreLocationClick = () => {
    history.push(routes.exploreLocation);
  };

  const onEventCategoryClick = () => {
    history.push({
      pathname: routes.events,
      state: {
        selectedCategory: category?.id,
      },
    });
  };

  const getImageUrl = () => {
    if (!currentLocation.details?.exploreLocation) {
      const categoryImage = metadata.images?.categories[category?.key];
      return categoryImage ? getCloudinaryImageLinkBySize(categoryImage) : DefaultEvent;
    }
    if (currentLocation.details?.exploreLocationImageUrl) {
      return getCloudinaryImageLinkBySize(currentLocation.details.exploreLocationImageUrl, IMAGE_WIDTH);
    }
    return ExploreLocation;
  };

  const getEventName = () => {
    if (currentLocation.details?.exploreLocation) {
      return 'Explore Location';
    }
    if (category?.name) {
      return `${category.name} Events`;
    }
    return '';
  };

  const getHandler = () => {
    if (currentLocation.details?.exploreLocation) {
      return onExploreLocationClick;
    }
    if (category?.name) {
      return onEventCategoryClick;
    }
    return () => {};
  };

  useEffect(() => {
    if (metadata.images) {
      const eventImage = metadata.images?.events[Math.round((Math.random() * 100) % metadata.images.events.length)];
      const benefitImage =
        metadata.images?.benefits[Math.round((Math.random() * 100) % metadata.images.benefits.length)];

      setEventsImage(eventImage);
      setBenefitsImage(benefitImage);
    }
  }, [metadata]);

  return (
    <Flex width="50%" flexDirection="column">
      <FlexWithGradientBackground
        onClick={onEventsClick}
        flexDirection="column"
        p={[12, 16, 28]}
        imageUrl={eventsImage}
        minHeight="50%"
        justifyContent="end"
        pointer>
        <Typography color={theme.color.white} variant="rightserif-400" fontSize={['20px', '30px', '40px']} mb="18px">
          Events
        </Typography>
        <Icon SVG={Arrow} width={53} />
      </FlexWithGradientBackground>
      <Flex pt={['4px', '7px']} justifyContent="space-between" minHeight="50%">
        <FlexWithGradientBackground
          pointer
          p={[12, 16, 28]}
          flexDirection="column"
          mr={['4px', '7px']}
          imageUrl={benefitsImage}
          width="50%"
          justifyContent="end"
          onClick={onMemberBenefitsClick}>
          <Typography color={theme.color.white} variant="rightserif-400" fontSize={['20px', '30px', '40px']} mb="18px">
            Member Benefits
          </Typography>
          <Icon SVG={Arrow} width={53} />
        </FlexWithGradientBackground>
        <FlexWithGradientBackground
          pointer
          p={[12, 16, 30]}
          flexDirection="column"
          imageUrl={getImageUrl()}
          width="50%"
          justifyContent="end"
          onClick={getHandler()}>
          <Typography color={theme.color.white} variant="rightserif-400" fontSize={['20px', '30px', '40px']} mb="18px">
            {getEventName()}
          </Typography>
          {!!category?.name && <Icon SVG={Arrow} width={53} />}
        </FlexWithGradientBackground>
      </Flex>
    </Flex>
  );
};

export default HomeGrid;
